import axios from 'axios';
import quick_dirty_string_checksum from '../security/security.js'

// todo: move into its file. Also oneGo() to its own.
// done?

// Results for hive-frame pictures
// Compare along `oneGo()` and poush-crytalised against it.
export async function fetchUserMLResults(user_id) {
  //const mimeType = 'image/jpg';
  const multiPartContent = [];

  const remoteBackendUrl = '/r/fetch_delta_results';
  const formData = new FormData();
  /// console.log('fetchUserMLResults::user_id', user_id);

  // Is this body?
  // will appear and fields inside `request.body` dict-object.
  formData.append('user_id', user_id);
  formData.append('user_signature', quick_dirty_string_checksum(user_id));

  const config = {
    headers: {
      'content-type': 'multipart/form-data',
      // 'content-type': 'text/json'
      'Access-Control-Allow-Origin': '*',
    },
  };

  // todo: log the version
  const client_version = '?';
  console.log('requesting ' + client_version);
  // the sent content is empty.
  const body_ = formData;

  try {
    // use GET? or post?
    // for now, GET
    // fornow-fornow: post, sorry (x2)
    const response = await axios.post(remoteBackendUrl, body_, config);

    console.log('response from backend: (B)');
    console.log(response.data);

    // see make_error_response() for structure of error contents
    if (response.data.isError) {
      // turn bakend error to front-end error
      throw new Error(response.data.error);
      // ignore response.data.message ?
    }

    return response.data;

  } catch (e) {
    console.error(e);
    alert(e + '');
    throw e;
    /* todo: handle exception from user pov
        (also test catch)
        For a reasonable UX and UX-ops (at least give some feedback so that they can call support)  UX-ops = "support"
    */
  }
  // todo: catch exception (also test catch)
}

export default fetchUserMLResults;
